import React from 'react';

import {
	FormControl as ChakraFormControl,
	FormLabel,
	FormErrorMessage,
	FormHelperText,
} from '@chakra-ui/react';
import { GlobalError } from 'react-hook-form';

type FormControlProps = {
	name: string;
	label: string;
	error?: GlobalError;
	helperText?: string;
	required?: boolean;
	children: React.ReactNode;
	className?: string;
};

export const FormControl = ({
	name,
	label,
	error,
	helperText,
	required,
	children,
	...rest
}: FormControlProps) => {
	return (
		<ChakraFormControl isInvalid={error !== undefined} {...rest}>
			<FormLabel htmlFor={name} className="text-secondary-700">
				{label}
				{!required && (
					<span className="ml-1 text-sm font-normal text-secondary-700">(optional)</span>
				)}
			</FormLabel>
			{children}
			{!!error ? (
				<FormErrorMessage>{error.message}</FormErrorMessage>
			) : (
				!!helperText && (
					<FormHelperText className="!text-secondary-700">{helperText}</FormHelperText>
				)
			)}
		</ChakraFormControl>
	);
};
